import Cookies from 'js-cookie'

const fontSizeSwapWidth = 1024
let fontSizeVpWidth     = null
let fontSizeTarget      = null
let fontSizeDecreaseBtn = null
let fontSizeIncreaseBtn = null
let fontSizeMaxBtn 		= null
let fontSizeCurrent     = null
let fontSizeCookie      = null
let fontSizeBtns		= null
// let fontSizeStep        = 4
let fontSizeStep        = 8
let fontSizeMin         = 16
// let fontSizeMax         = 24
let fontSizeMax         = 32


export function initialize() {
  inspectEnvironment()
}

export function inspectEnvironment() {
  fontSizeVpWidth = window.innerWidth

  if ((fontSizeVpWidth >= fontSizeSwapWidth)) {
    fontSizeTarget      = document.querySelector('html')
    fontSizeBtns      = document.querySelector('.font-size button')
    fontSizeDecreaseBtn = document.querySelector('[data-font-decrease]')
    fontSizeIncreaseBtn = document.querySelector('[data-font-increase]')
    fontSizeMaxBtn = document.querySelector('[data-font-max]')
    fontSizeCookie      = (Cookies.get('currentFontSize')) ? Cookies.get('currentFontSize') : fontSizeMin
    fontSizeCurrent     = parseFloat(window.getComputedStyle(fontSizeTarget, null).getPropertyValue('font-size'))

    if (!fontSizeTarget || !fontSizeDecreaseBtn || !fontSizeIncreaseBtn) {
      return
    }

    addListeners()
    setInitial()
  }
}


export function addListeners() {
  fontSizeDecreaseBtn.addEventListener('click', decreaseFontSize, false)
  fontSizeIncreaseBtn.addEventListener('click', increaseFontSize, false)
  fontSizeMaxBtn.addEventListener('click', maxFontSize, false)
}


export function setInitial() {
  if(fontSizeCookie == (fontSizeMin + fontSizeStep)) {
    fontSizeIncreaseBtn.classList.add("active")		
	  $('body').addClass('unfixed-header zoomed');
  } else if(fontSizeCookie == fontSizeMax) {
	  fontSizeMaxBtn.classList.add("active");
	  $('body').addClass('unfixed-header zoomed');
  } else { 
    fontSizeDecreaseBtn.classList.add("active")		
  }
  if (fontSizeCookie !== fontSizeCurrent) {
    fontSizeTarget.style.fontSize = fontSizeCookie + 'px'
    fontSizeCurrent               = fontSizeCookie
  }
}

export function removeActiveClass() {
  $('body').removeClass('unfixed-header zoomed');
  fontSizeDecreaseBtn.classList.remove('active')
  fontSizeIncreaseBtn.classList.remove('active')
  fontSizeMaxBtn.classList.remove('active')
}

function bookmarksModalPosition() {
	var headerHeight = $('header').outerHeight(false);
	$('.bookmarks-component').css('top',headerHeight);
}

export function decreaseFontSize() {
  removeActiveClass();
  fontSizeDecreaseBtn.classList.add("active")
  if (fontSizeCurrent > fontSizeMin) {
    fontSizeCurrent = parseInt(fontSizeMin)
    fontSizeTarget.style.fontSize = fontSizeCurrent + 'px'
    Cookies.set('currentFontSize', fontSizeCurrent)
	 setTimeout(function() {
	 	bookmarksModalPosition();
	 },500);
  }
}


export function increaseFontSize() {
    removeActiveClass();
  fontSizeIncreaseBtn.classList.add("active")
  if (fontSizeCurrent !== (fontSizeMax - fontSizeStep)) {
    fontSizeCurrent = parseInt(fontSizeMin + fontSizeStep)
    fontSizeTarget.style.fontSize = fontSizeCurrent + 'px'
    Cookies.set('currentFontSize', fontSizeCurrent)
	  $('body').addClass('unfixed-header zoomed');
  }
}

export function maxFontSize() {
    removeActiveClass();
  fontSizeMaxBtn.classList.add("active")
  if (fontSizeCurrent < fontSizeMax) {
    fontSizeCurrent = parseInt(fontSizeMax)
    fontSizeTarget.style.fontSize = fontSizeCurrent + 'px'
    Cookies.set('currentFontSize', fontSizeCurrent)
	  $('body').addClass('unfixed-header zoomed');
  }
}